var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from "react";
import { FlowContext, FlowDispatchContext } from "../components/Context";
import { dfKey, formDataInStorage, readDfStorage, removeDynamicFormData, saveToDfStorage } from "../services/helperLib";
import { checkPageVisible, clampDependentCashOutFields, getFieldConfig } from '../services/dfUtils';
;
export function getPages(flow) {
    var pageCollection = flow.pageCollection || {};
    //US412898: Reading from session store, Gets updated on new session
    var id = readDfStorage("loanPurpose");
    //const id = fieldValueInStorage("loanPurpose");
    var pages;
    try {
        pages = flow.subFlows && flow.subFlows[id].pages.filter(function (pageId) { return checkPageVisible(pageCollection[pageId]); }) || [];
    }
    catch (e) {
        pages = [];
    }
    return pages;
}
function getCompletedPages(flow) {
    getPages(flow).filter(function (pageId) {
        var pageConfig = flow.pageCollection ? flow.pageCollection[pageId] : undefined;
        if (!pageConfig)
            return false;
    });
    return [];
}
function getUpdatedStep(index, flow, operation) {
    var pages = getPages(flow);
    var pageCollection = flow.pageCollection || {};
    var totalPages = pages.length;
    if (index >= totalPages) {
        return {};
    }
    var pageId = pages[index];
    if (!pageCollection || !pageCollection[pageId]) {
        throw new Error("Page ID '".concat(pageId, "' not found in pageCollection"));
    }
    return {
        currentStepIndex: index,
        currentStep: pageId,
        isFirstStep: index === 0,
        isLastStep: index === totalPages - 1,
    };
}
// Cash-out amount is recalculated/clamped against home value & loan amount only when the
// user navigates (Next/Back) - not on every keystroke in the home value / loan amount fields.
function applyCashOutClamp(formData) {
    var cashOutUpdates = clampDependentCashOutFields(formData);
    Object.entries(cashOutUpdates).forEach(function (_a) {
        var fieldId = _a[0], fieldData = _a[1];
        if (fieldData.fieldValue)
            saveToDfStorage(fieldId, fieldData.fieldValue);
    });
    return __assign(__assign({}, formData), cashOutUpdates);
}
export var emptyFlowState = {
    flowId: 'simpleFlowPurchase',
    config: { path: '', pages: [], pageCollection: {} },
    currentStepIndex: 0,
    currentStep: '',
    isFirstStep: true,
    isLastStep: true,
    formData: {},
    dynamicForm: ''
};
export function hydrateFormData() {
    var sessionDf = formDataInStorage();
    var dfConfig = readDfStorage("dfConfig") || {}; //remove?
    var res = {};
    Object.keys(sessionDf).forEach(function (key) {
        var baseConfig = getFieldConfig(key);
        var cmsConfig = dfConfig[key] || {}; //is this necessary?
        res[key] = {
            config: __assign(__assign({}, baseConfig), cmsConfig),
            fieldValue: sessionDf[key],
        };
    });
    return res;
}
export function flowReducer(flowState, action) {
    switch (action.type) {
        case 'Next': {
            if (flowState.isLastStep) {
                return flowState;
            }
            var res = __assign(__assign(__assign({}, flowState), { formData: applyCashOutClamp(flowState.formData) }), getUpdatedStep(flowState.currentStepIndex + 1, flowState.config, "next"));
            saveToDfStorage(dfKey(), res);
            return res;
        }
        case 'Back': {
            if (action.isFirstStep) {
                return flowState;
            }
            var res = __assign(__assign(__assign({}, flowState), { formData: applyCashOutClamp(flowState.formData) }), getUpdatedStep(flowState.currentStepIndex - 1, flowState.config, "back"));
            saveToDfStorage(dfKey(), res);
            return res;
        }
        case 'Skip': {
            if (action.isLastStep) {
                return flowState;
            }
            var res = __assign(__assign(__assign({}, flowState), { formData: __assign(__assign({}, flowState.formData), action.formData) }), getUpdatedStep(flowState.currentStepIndex + 1, flowState.config, "next"));
            saveToDfStorage(dfKey(), res);
            return res;
        }
        case 'SwitchFlow': {
            var res = __assign(__assign({}, flowState), { formData: __assign({}, action.formData) });
            res = __assign(__assign({}, res), getUpdatedStep(flowState.currentStepIndex, flowState.config, "next"));
            saveToDfStorage(dfKey(), res);
            return res;
        }
        case 'Submit': {
            removeDynamicFormData();
            return __assign(__assign({}, emptyFlowState), { formData: {} });
        }
        case 'UpdateFormData': {
            if (action.formData) {
                Object.entries(action.formData).forEach(function (_a) {
                    var fieldId = _a[0], fieldData = _a[1];
                    if ((fieldData === null || fieldData === void 0 ? void 0 : fieldData.fieldValue) !== undefined) {
                        saveToDfStorage(fieldId, fieldData.fieldValue);
                    }
                });
            }
            var res = __assign(__assign({}, flowState), { formData: __assign(__assign({}, flowState.formData), action.formData) });
            if (action.autoNext && !flowState.isLastStep) {
                res = __assign(__assign({}, res), getUpdatedStep(flowState.currentStepIndex + 1, flowState.config, "next"));
            }
            saveToDfStorage(dfKey(), res);
            return res;
        }
        case 'UpdateFormDataWithCurrentIndex': {
            var res = __assign(__assign({}, flowState), { formData: __assign(__assign({}, flowState.formData), action.formData) });
            res = __assign(__assign({}, res), getUpdatedStep(1, flowState.config, "next"));
            saveToDfStorage(dfKey(), res);
            return res;
        }
        case 'ResetFormData': {
            return __assign(__assign({}, flowState), { formData: {} });
        }
        case 'Initialize': {
            var res = __assign(__assign({}, flowState), action);
            saveToDfStorage(dfKey(), res);
            return res;
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}
export function useFlow() {
    return useContext(FlowContext);
}
export function useFlowDispatch() {
    return useContext(FlowDispatchContext);
}
